import { BidAgainFormValues } from './../types/formikTypes'
import { useEffect, useRef } from 'react'
import { FormikHelpers } from 'formik'
import { useBiddingSidePanel } from 'store/useBiddingSidePanelStore'
import { useVehicleStore } from 'store/useVehicleStore'
import { useGlobalStore } from 'store/useGlobalStore'

// when dealership changed by dealership dropdown manage bids page
// we want all clients of that user (eg: watchlist side panel, other tabs of manage bid) follow the updated BiddingDealerID
// this hook also activate when we open side panel
export const useSidePanelRealTimeUpdateDealer = (
  formikHelper: FormikHelpers<BidAgainFormValues>,
  dealershipUpdatedCallback: () => void
) => {
  const biddingVehicleInstanceId = useBiddingSidePanel((state) => state.biddingVehicleInstanceId)
  const isPurchaseExclusive = useBiddingSidePanel((state) => state.isPurchaseExclusive)
  const biddingVehicle = useVehicleStore((state) =>
    state.vehicles?.find((vehicleData) => vehicleData.vehicle.InstanceID === biddingVehicleInstanceId)
  )
  const { CurrentBuyerID } = useGlobalStore((state) => state.userClaims)
  const hasInitializedRef = useRef(false)

  useEffect(() => {
    // Reset initialization flag when vehicle changes
    if (biddingVehicleInstanceId) {
      hasInitializedRef.current = false
    }
  }, [biddingVehicleInstanceId])

  useEffect(() => {
    if (!biddingVehicleInstanceId) return

    formikHelper.setFieldValue('BiddingDealerID', CurrentBuyerID, false)
    formikHelper.setFieldValue('BidAmount', biddingVehicle?.auctionInfo?.NextBidAmount, false)

    // Always call dealershipUpdatedCallback on initial load to fetch data
    // For purchase exclusive, we only need it once (no real-time updates needed)
    if (!hasInitializedRef.current || !isPurchaseExclusive) {
      dealershipUpdatedCallback()
      hasInitializedRef.current = true
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPurchaseExclusive, biddingVehicleInstanceId])
}
